<template>
    <div class="home-app-admin">
        <heading title="App Admin Dashboard" tag="home-project-title"/>
        <b-row>
            <div class="col-lg-6">
                <notification-list-widget/>
            </div>
            <div class="col-lg-6">
                <message-list-widget/>
            </div>
        </b-row>
        <b-row>
            <div class="col-sm-12">
                <project-list-widget
                    :title="'Projects'"
                    :show-exemptions="true"/>
            </div>
        </b-row>
        <b-row>
            <div class="col-sm-3">
                <reporting-chart-pie
                    title="User Type Breakdown"
                    series-name="Users"
                    :data="userChartData"/>
            </div>
            <div class="col-sm-3">
                <reporting-chart-bar
                    title="Equipment Compliance Breakdown"
                    series-name="Equipment"
                    :data="complianceChartData"/>
            </div>
            <div class="col-sm-3">
                <reporting-chart-pie
                    title="Equipment Type Breakdown"
                    series-name="Equipment"
                    :data="equipmentChartData"/>
            </div>
            <div class="col-sm-3">
                <reporting-chart-pie
                    title="Exemption Type Breakdown"
                    series-name="Exemption"
                    :data="exemptionChartData"/>
            </div>
            <div class="col-sm-3">
                <reporting-chart-pie
                    title="Companies Created"
                    no-data-string="No data for this period"
                    series-name="Companies"
                    :data="companyChartData"/>
                <b-col class="d-flex flex-column align-items-center mb-3">
                    <h4>Total: {{ totalCompaniesCreated }}</h4>
                    <b-row>
                        <div v-for="(point, i) in companyChartData" :key="`company-count-${i}`" class="mx-2">
                            {{ point.name }}: {{ point.y}}
                        </div>
                    </b-row>
                </b-col>
                <div class="d-flex justify-content-center flex-column">
                    <b-row class="pb-1 justify-content-center">
                        <span class="col-3 text-center my-auto pl-0">Start: </span>
                        <b-form-input type="date"
                                      class="col-7 company-chart-period-select"
                                      v-model="companyChartPeriod.start"
                                      @change="onChangeCompanyChartPeriod"/>
                    </b-row>
                    <b-row class="justify-content-center">
                        <span class="col-3 text-center my-auto pl-0">End: </span>
                        <b-form-input type="date"
                                      class="col-7 company-chart-period-select"
                                      v-model="companyChartPeriod.end"
                                      @change="onChangeCompanyChartPeriod"/>
                    </b-row>
                </div>
            </div>
        </b-row>
    </div>
</template>

<script>

import Vue from 'vue'
import ReportingChartPie from '@/components/ReportingChartPie'
import * as _ from 'lodash'
import ChartConsts from '@/providers/ChartConsts'
import moment from 'moment'

export default Vue.extend({
    name: 'HomeAppAdmin',
    components: {
        ReportingChartPie,
    },
    data () {
        return {
            complianceChartData: [],
            userChartData: [],
            equipmentChartData: [],
            exemptionChartData: [],
            companyChartData: [],

            companyChartPeriod: {
                start: moment().subtract(1, 'years').format('YYYY-MM-DD'),
                end: moment().format('YYYY-MM-DD')
            },
            totalCompaniesCreated: 0,
        }
    },
    methods: {
        getComplianceChartData () {
            return this.$api.complianceChartData(this).then((response) => {
                let data = response.body.map((item) => {
                    item.data = _.keys(item.data).map((key) => {
                        return [key,+item.data[key]]
                    })
                    return item
                })
                return data
            })
        },
        getUserChartData () {
            return this.$api.userChartData(this).then((response) => {
                let points = []
                _.forIn(response.body, (value, key) => {
                    points.push({ name: ChartConsts.userLabels[key], y: +value })
                })
                return points
            })
        },
        getEquipmentChartData () {
            return this.$api.equipmentBreakdownChartData(this).then((response) => {
                let points = []
                _.forIn(response.body, (value, key) => {
                    points.push({ name: ChartConsts.equipmentBreakdownLabels[key], y: +value })
                })
                return points
            })
        },
        getExemptionChartData () {
            return this.$api.exemptionBreakdownChartData(this).then((response) => {
                let points = []
                _.forIn(response.body, (value, key) => {
                    points.push({ name: ChartConsts.exemptionBreakdownLabels[key], y: +value })
                })
                return points
            })
        },
        getCompanyChartData() {
            const now = moment(this.companyChartPeriod.end).format('YYYY-MM-DD') + ' 23:59:59'
            const start = moment(this.companyChartPeriod.start).format('YYYY-MM-DD HH:mm:ss')
            return this.$api.companyBreakdownChartData(this, start, now).then((response) => {
                let points = []
                this.totalCompaniesCreated = 0
                _.forIn(response.body, (value, key) => {
                    if (+value !== 0) {
                        points.push({ name: ChartConsts.companyBreakdownLabels[key], y: +value })
                        this.totalCompaniesCreated += +value
                    }
                })
                return points
            })
        },
        onChangeCompanyChartPeriod() {
            if (this.companyChartPeriod.start && this.companyChartPeriod.end) {
                this.getCompanyChartData().then((data) => this.companyChartData = data)
            }
        },
    },
    beforeMount () {
        this.getComplianceChartData().then((data) => this.complianceChartData = data)
        this.getUserChartData().then((data) => this.userChartData = data)
        this.getEquipmentChartData().then((data) => this.equipmentChartData = data)
        this.getExemptionChartData().then((data) => this.exemptionChartData = data)
        this.getCompanyChartData().then((data) => this.companyChartData = data)
    }
})
</script>

<style lang="scss">
.home-app-admin {
    .company-chart-period-select {
        max-width: 10em;
    }
}
</style>
